import { render, staticRenderFns } from "./ChangePassWordForm.vue?vue&type=template&id=316754af&scoped=true&"
import script from "./ChangePassWordForm.vue?vue&type=script&lang=js&"
export * from "./ChangePassWordForm.vue?vue&type=script&lang=js&"
import style0 from "./ChangePassWordForm.vue?vue&type=style&index=0&id=316754af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316754af",
  null
  
)

export default component.exports